import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ListWithDetails from 'components/Common/ListWithDetails';
import PerformanceUtils from 'services/PerformanceUtils';
import FaxBadge from 'components/HealthRecords/Faxes/FaxBadge';
import FaxDetails from 'components/HealthRecords/Faxes/FaxDetails';

const FaxList = ({ title, faxes, renderDetails, renderBadge, autoLoad, noDetail, onSelect }) => {
  let [sortedFaxes, setSortedFaxes] = useState([]);

  useEffect(() => {
    setSortedFaxes(PerformanceUtils.sortBy(faxes || []));
  }, [faxes]);

  return (
    <ListWithDetails
      title={title}
      items={sortedFaxes}
      renderBadge={(item) => <Badge item={item} renderBadge={renderBadge} />}
      renderDetails={(item) => (
        <Details
          key={item.id}
          item={item}
          renderDetails={renderDetails}
          autoLoad={autoLoad}
          onClose={() => onSelect?.()}
        />
      )}
      noDetail={noDetail}
      onSelect={onSelect}
    />
  );
};

const Badge = React.memo(({ item, renderBadge }) =>
  renderBadge ? renderBadge(item) : <FaxBadge item={item} />,
);

const Details = React.memo(({ item, renderDetails, autoLoad, onClose }) =>
  renderDetails ? (
    renderDetails(item)
  ) : (
    <FaxDetails fax={item} allowExpand={true} autoLoad={autoLoad} onClose={onClose} />
  ),
);

export const FaxDetailOnly = Details;

FaxList.propTypes = {
  faxes: PropTypes.array,
  title: PropTypes.string,
  renderBadge: PropTypes.func,
  renderDetails: PropTypes.func,
};

export default React.memo(FaxList);
